import { Injectable } from '@angular/core';
import { CommMatrixTypeApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { CommMatrixTypeAction } from '../actions';

@Injectable()
export class CommMatrixTypeEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(CommMatrixTypeAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => CommMatrixTypeAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: CommMatrixTypeApiService, private _actions$: Actions, private _store: Store) { }
}
